export default __webpack_public_path__ + "static/media/55nam.b49b8385.jpg";